import _some from 'lodash/some';
import _isUndefined from 'lodash/isUndefined';
import _template from 'lodash/template';

export default {
  translation: (state) => (key, interpolationParams = null) => {
    const translated = state.translations[key] || key;

    if (interpolationParams) {
      const compiled = _template(translated, { interpolate: /{([\s\S]+?)}/g });
      return compiled(interpolationParams);
    }

    return translated;
  },
  languages: (state) => state.languages,
  user: (state) => state.user,
  userHasModule: (state) => (key) => (state.userModules[key]
    ? state.userModules[key].view && state.userModules[key].edit
    : false),
  aggregators: (state) => state.filters.aggregators,
  categories: (state) => state.filters.categories,
  providers: (state) => state.filters.providers,
  isDragging: (state) => state.isDragging,
  getFilterParams: (state) => state.filterParams,
  isReorderingAvailable: (state) => {
    const forbiddenFilters = ['aggregator', 'category', 'provider', 'new', 'active', 'tournament']; // must not have a value
    const strictlyForbiddenFilters = ['enabled']; // must not exist on filterParams at all
    const filtersWithValue = {
      active: true,
    };

    const hasForbiddenFilters = _some(forbiddenFilters, (item) => state.filterParams[item])
      || _some(strictlyForbiddenFilters, (item) => !_isUndefined(state.filterParams[item]));

    const hasForbiddenValues = _some(filtersWithValue, (value, key) => {
      if (_isUndefined(state.filterParams[key])) return false;

      return state.filterParams[key] !== value;
    });

    return !hasForbiddenFilters
      && !hasForbiddenValues
      && state.filterParams.standalone;
  },
};
